import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_8: FaireProductEntity = {
  token: "matcha-8",
  type: "product",
  name: "Botanical Gardens Tea",
  brandName: "Flowrs Tea",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/394689d733fe9b5ba26b134c5e8fba226fdfac25dadbdb967bfbcab17d042bb0.png",
  priceDollars: 3,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/394689d733fe9b5ba26b134c5e8fba226fdfac25dadbdb967bfbcab17d042bb0.png",
  weight: 0.3,
  dimensions: {
    width: 3,
    height: 5,
    depth: 2,
  },
  description: "Botanical gardens matcha tea blend",
  categoryTokens: ["cat_food-beverages"],
  tags: ["matcha", "tea", "botanical", "wellness", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
